<nav
  class="navbar container navbar-default navbar-static-top dropdownMyAccount"
  [ngClass]="{ 'disabled-div': disableHeader }"
>
  <div class="left">
    <a href="/home" *ngIf="showLogo && configService.getLogo('BA_LOGO_DESKTOP')">
      <img class="logo" [src]="configService.getLogo('BA_LOGO_DESKTOP')" />
    </a>

    <a href="/home" *ngIf="!showLogo && configService.getLogo('BA_LOGO_MOBILE')">
      <img class="logo" [src]="configService.getLogo('BA_LOGO_MOBILE')" />
    </a>
  </div>

  <form class="alignme profile">
    <!-- Search Icon -->
    <div class="text-decoration" (click)="search()">
      <i class="fa fa-search"></i>
    </div>

    <!-- Login / User Section -->
    <div class="alignme">
      <!-- When user is NOT logged in -->
      <div *ngIf="!userName" class="d-flex align-items-center">
        <!-- Login -->
        <a (click)="proceedWithLogin()" class="text-decoration alignme d-flex align-items-center me-0">
          <button type="button" class="dropdown me-1 profile-dropdown"></button>
          <span class="profile-name">LOG IN</span>
        </a>
      </div>

      <!-- When user is logged in -->
      <div *ngIf="userName" class="d-flex align-items-center">
        <button
          type="button"
          class="text-hover dropdown me-1 profile-dropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-offset="10,20"
        ></button>

        <div class="dropdown-menu">
          <a class="dropdown-item" href="profile"><i class="fa fa-home fa-smx me-2"></i>My Account</a>
          <a class="dropdown-item" *ngIf="user.isAdminUser" href="forms/ndc-voucher-logs"><i class="fa fa-code fa-smx me-2"></i>Admin Control</a>
          <a class="dropdown-item" (click)="signOutUser()"><i class="fa fa-user-times me-2"></i>Logout</a>
        </div>

        <span class="profile-name" data-bs-toggle="dropdown" aria-expanded="false" data-offset="10,20">
          <a>{{ userName }}</a>
        </span>
      </div>
    </div>
  </form>


</nav>
